var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avt-contain",style:(this.size
      ? {
          height: ((this.size) + "px"),
          width: ((this.size) + "px"),
          'border-radius': ((this.size * 0.12) + "px")
        }
      : {}),on:{"mouseenter":function($event){_vm.showChallenge=true},"mouseleave":function($event){_vm.showChallenge=false}}},[_c('router-link',{attrs:{"to":("/user/" + _vm.username)}},[_c('img',{style:(this.size
          ? {
              height: ((this.size) + "px"),
              width: ((this.size) + "px"),
              'border-radius': ((this.size * 0.12) + "px")
            }
          : {}),attrs:{"src":require(("../assets/" + (_vm.setAvatar ? ("avatars/" + _vm.setAvatar + ".png") : 'unknown.png'))),"alt":""}})]),(
      _vm.online ||
        (_vm.online === undefined &&
          !!_vm.onlineUsers.map(function (u) { return u.username; }).includes(_vm.username))
    )?_c('div',{staticClass:"online-status",style:(this.size
        ? {
            width: ((this.size * 0.22) + "px"),
            height: ((this.size * 0.22) + "px"),
            bottom: ((-(this.size * 0.22 * 0.3)) + "px"),
            right: ((-(this.size * 0.22 * 0.3)) + "px"),
            'border-radius': ((this.size * 0.22 * 0.5) + "px")
          }
        : {})}):_vm._e(),(_vm.challengeModal && _vm.showChallenge)?_c('div',{staticClass:"challenge-modal",style:({bottom: this.size})},[_c('p',{staticStyle:{"margin-bottom":"5px"}},[_c('router-link',{attrs:{"to":("/user/" + _vm.username)}},[_vm._v(_vm._s(_vm.username)+" ")]),(_vm.rank)?_c('small',[_vm._v("("+_vm._s(_vm.rank)+")")]):_vm._e()],1),_c('button',{attrs:{"disabled":_vm.credits < 5},on:{"click":_vm.createPrivateDuel}},[_vm._v("CHALLENGE "),_vm._m(0)])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"credit-display"},[_vm._v("5"),_c('img',{attrs:{"src":require("@/assets/credits.png")}})])}]

export { render, staticRenderFns }